import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../security/AuthContext';
import { loginUser } from '../services/AuthService';

export function Login() {
  const { login } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    const formData = new FormData(e.target);
    const email = formData.get('email');
    const password = formData.get('password');

    try {
      const loginResult = await loginUser(email.toString(), password.toString());
      console.log('Login result:', loginResult);
      if (loginResult.success) {
        localStorage.setItem('token', loginResult.jwt);
        localStorage.setItem('refreshToken', loginResult.refreshToken);
        setSuccess('Login successful! Redirecting...');
        login(loginResult.user);
        setTimeout(() => {
          const origUrl = localStorage.getItem("originalUrl")
          localStorage.removeItem("originalUrl")
          var url = '/';
          if (origUrl) {
            url = origUrl.substring(origUrl.replace("//", "").indexOf("/") + 2)
          }
          navigate(url);
        }, 500);
      } else {
        setError(loginResult.details);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'An error had occurred. Please try again.';
      setError(errorMessage);
      console.error('Login failed:', errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-6">Login</h2>
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
            {error}
          </div>
        )}
        {success && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
            {success}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-xl text-gray-800">
              Email Address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              className="mt-1 block w-full text-md px-3 py-2 border border-gray-400 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 placeholder:text-lg placeholder:text-gray-400"
              placeholder="you@example.com"
              style={{ fontSize: '1.15rem' }}
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-xl text-gray-800">
              Password
            </label>
            <div className="relative">
              <input
                id="password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                required
                className="mt-1 block w-full text-base px-3 py-2 border border-gray-400 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 placeholder:text-lg placeholder:text-gray-400"
                placeholder="••••••••"
                style={{ fontSize: '1rem' }}
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-600 hover:text-gray-800"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <i className={showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
              </button>
            </div>
            <p className="mt-2 text-sm text-gray-700">
              <Link to="/forgot-password" className="font-medium text-indigo-500 hover:text-indigo-600">
                Forgot Password?
              </Link>
            </p>
          </div>
          <div>
            <button
              type="submit"
              className={`w-full text-xl flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                loading ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-500 hover:bg-indigo-600 cursor-pointer'
              } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
              disabled={loading}
            >
              {loading ? 'Signing In...' : 'Login'}
            </button>
            
          </div>
          
        </form>
        <p className="mt-4 text-center text-gray-700">
          Don't have an account?{' '}
          <Link to="/signup" className="font-medium text-indigo-500 hover:text-indigo-600">
            Sign up
          </Link>
        </p>
         <div className=" bottom-2 w-full text-center py-4">
        <p className="text-base">© 2025 SendFalcon. All rights reserved.</p>
      </div>
      </div>
    </div>
  );
};